export default {
  state: {
    productTrustSelected: {},
  },
  mutations: {
    SET_PRODUCTS_TRUST_SELECTED(state, payload) {
      console.log("Inside SET_PRODUCTS_TRUST_SELECTED - payload:", payload);
      state.productTrustSelected = payload;
    },
  },
  getters: {
    GET_PRODUCTS_TRUST_SELECTED(state) {
      return state.productTrustSelected
    },
  },
};
